
<template>
  <div class="container-fluid m-0 p-0">

    <!-- Überschrift -->
    <div class="row justify-content-center">
      <div class="col-md-8 text-center mt-5 pt-5">
        <h2>Cybervorfall of the Day!</h2>
        <p class="text-muted">
          Täglich ein aktueller Cybervorfall
        </p>
      </div>
    </div>

    <!-- Tabellenüberschrift -->
    <div class="row bg-white pt-5 pb-4 ms-5 border-bottom fw-bold">
      <div class="col-md-2 p-0 text-center">
        Datum
      </div>
      <div class="col-md-10 p-0">
        Beschreibung
      </div>
    </div>

    <!-- Liste -->
    <div
      v-for="eintrag in sichtbareVorfaelle"
      :key="eintrag.datum"
      class="row ms-5 py-3 border-bottom align-items-center"
    >
      <div class="col-md-2 p-0 text-center">
        {{ datumFormatieren(eintrag.datum) }}
      </div>

      <div class="col-md-10 p-0">
        <a
          href="#"
          @click.prevent="grafikAnzeigen(eintrag)"
        >
          {{ eintrag.beschreibung }}
        </a>
      </div>
    </div>

    <!-- Popup -->
    <div
      v-if="ausgewaehlterVorfall"
      class="cyber-overlay"
      @click.self="grafikSchliessen"
    >
      <div class="cyber-popup">

        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="m-0">
            {{ ausgewaehlterVorfall.beschreibung }}
          </h5>

          <button
            type="button"
            class="btn-close"
            aria-label="Schließen"
            @click="grafikSchliessen"
          >
          </button>
        </div>

        <img
          :src="grafikPfad"
          class="cyber-grafik"
          alt="Cybervorfall des Tages"
        />

      </div>
    </div>

  </div>
</template>

<script>
export const cybervorfaelle = {
        "09102026": {
          beschreibung: "Operation KillSwitch entschlüsselt",
          grafik: "Cybervorfall_ Operation KillSwitch entschlüsselt.png"
        },  
        "12102026": {
          beschreibung: "Cybervorfall bei Fakturownia_InvoiceOcean",
          grafik: "Cybervorfall bei Fakturownia_InvoiceOcean.png"
        },
        "13102026": {
          beschreibung: "Schweizer Pensionskasse - Datenleck bei Zulieferer",
          grafik: "Cybervorfall bei PUBLICA-Zulieferer.png"
        },
        "14102026": {
          beschreibung: "Times Car - 6,6 Millionen Accounts betroffen",
          grafik: "Cybervorfall bei Times Car.png"
        },
        "15102026": {
          beschreibung: "Revolut-Datenklau - Datenklau und Erpressung",
          grafik: "Cybervorfall des Tages_ Revolut-Datenklau.png"
        },
        "16102026": {
          beschreibung: "Arizona-Gerichtssystem - Datenleck entdeckt",
          grafik: "Cybervorfall im Arizona-Gerichtssystem.png"
        },
        "19102026": {
          beschreibung: "US-Verteidigungsministerium - Millionen Personaldaten betroffen",
          grafik: "Cybervorfall im US-Verteidigungsministerium.png"
        },
        "20102026": {
          beschreibung: "Dänemark  -  8,8 Millionen Datensätze",
          grafik: "Dänischer Cybervorfall_ 8,8 Millionen Datensätze.png"
        },
        "21102026": {
          beschreibung: "FBI Massiver Datendiebstahl",
          grafik: "FBI-Cybervorfall_ Massiver Datendiebstahl.png"
        },
        "22102026": {
          beschreibung: "Kritische PHP-Sicherheitslücken geschlossen",
          grafik: "Kritische PHP-Sicherheitslücken geschlossen.png"
        },
        "23102026": {
          beschreibung: "Britische Krankenhäuser - Cyberangriff auf Dienstleister Synnovis",
          grafik: "Cyberangriff auf britische Krankenhäuser.png"
        },
        "26102026": {
          beschreibung: "Japan - 4 Cloud-Regionen lahmgelegt",
          grafik: "ChatGPT-Bild 26. Okt. 2026, 10_03_34.png"
        },
        "27102026": {
          beschreibung: "Datenleck an Hochschule CNAM",
          grafik: "ChatGPT-Bild 19. Okt. 2026, 07_39_15.png"
        },
        "28102026": {
          beschreibung: "Ahold Delhaize: IT-Systeme vorsorglich abgeschaltet",
          grafik: "ChatGPT-Bild 19. Okt. 2026, 07_39_05.png"
        },
        "29102026": {
          beschreibung: "Hacker manipulieren Supermarktkühlung",
          grafik: "ChatGPT-Bild 19. Okt. 2026, 07_38_52.png"
        },
        "30102026": {
          beschreibung: "Britische Legal Aid Agency  - Datenleck bis 1978",
          grafik: "ChatGPT-Bild 19. Okt. 2026, 07_38_44.png"
        },
        "02112026": {
          beschreibung: "Amerikanischer Energieversorger betroffen",
          grafik: "ChatGPT-Bild 19. Okt. 2026, 07_38_35.png"
        },
        "03112026": {
          beschreibung: "USA - Cybervorfall stoppt Insolvenz - Mitteilungen",
          grafik: "ChatGPT-Bild 19. Okt. 2026, 07_38_20.png"
        },  
        "04112026": {
          beschreibung: "Datenabfluß bei Golf-Plattform GDO",
          grafik: "ChatGPT-Bild 19. Okt. 2026, 07_37_45.png"
        },         
        "05112026": {
          beschreibung: "ASOS Datenzugriff auf Mitarbeiterzugangsdaten",
          grafik: "Cyberangriff auf ASOS_ Datenzugriff erklärt.png"
        },
        "06112026": {
          beschreibung: "Cybervorfall bei Burger King Japan",
          grafik: "Cybervorfall bei Burger King Japan.png"
        },  
        "09112026": {
          beschreibung: "Angriff auf Cloud-Backup‑Dienst",
          grafik: "ConnectWise_ Angriff auf Cloud-Backup‑Dienst.png"
        },  
        "10112026": {
          beschreibung: "PingCAP - Datenabfluss aus Cloud-Umgebung",
          grafik: "Cybervorfall_of_the_Day_PingCAP.png"
        },  
        "11112026": {
          beschreibung: "Quest Diagnostics - Datenleck bei Patienteninformationen",
          grafik: "Cybervorfall_of_the_Day_Quest_Diagnostics.png"
        },  
        "12112026": {
          beschreibung: "Toronto Crime Stoppers - Datenleck",
          grafik: "Cybervorfall_of_the_Day_Toronto_Crime_Stoppers.png"
        },  
        "13112026": {
          beschreibung: "",
          grafik: ".png"
        },  
        "16112026": {
          beschreibung: "",
          grafik: ".png"
        },  
        "17112026": {
          beschreibung: "",
          grafik: ".png"
        },  
        "18112026": {
          beschreibung: "",
          grafik: ".png"
        },  
        "19112026": {
          beschreibung: "",
          grafik: ".png"
        },  
        "20112026": {
          beschreibung: "",
          grafik: ".png"
        },  
        "23112026": {
          beschreibung: "",
          grafik: ".png"
        },  
        "24112026": {
          beschreibung: "",
          grafik: ".png"
        },  
        "25112026": {
          beschreibung: "",
          grafik: ".png"
        },  
        "26112026": {
          beschreibung: "",
          grafik: ".png"
        },  
        "27112026": {
          beschreibung: "",
          grafik: ".png"
        },  
        "30112026": {
          beschreibung: "",
          grafik: ".png"
        },  
        "01122026": {
          beschreibung: "",
          grafik: ".png"
        },  
        "02122026 ": {
          beschreibung: "",
          grafik: ".png"
        },   
        "03122026 ": {
          beschreibung: "",
          grafik: ".png"
        },   
        "04122026 ": {
          beschreibung: "",
          grafik: ".png"
        },  
};

export default {
  name: "CybervorfallPage",

  data: function () {
    return {
      ausgewaehlterVorfall: null,
      heute: "",  
      vorfaelle: cybervorfaelle,
    };
  },

  computed: {
    sichtbareVorfaelle: function () {
      var self = this;

      return Object.keys(this.vorfaelle)
        .filter(function (datum) {
          var iso = self.datumZuISO(datum);
          var tag = new Date(iso + "T12:00:00").getDay();

          return (
            iso >= "2026-10-09" &&
            iso <= self.heute &&
            tag >= 1 &&
            tag <= 5
          );
        })
        .sort(function (a, b) {
          return self.datumZuISO(b).localeCompare(
            self.datumZuISO(a)
          );
        })
        .map(function (datum) {
          return {
            datum: datum,
            beschreibung: self.vorfaelle[datum].beschreibung,
            grafik: self.vorfaelle[datum].grafik
          };
        });
    },

    grafikPfad: function () {
      if (!this.ausgewaehlterVorfall) {
        return "";
      }

      return "/Cybervorfall/" +
        this.ausgewaehlterVorfall.grafik;
    }
  },

  methods: {
    datumZuISO: function (datum) {
      return (
        datum.substring(4, 8) + "-" +
        datum.substring(2, 4) + "-" +
        datum.substring(0, 2)
      );
    },

    datumFormatieren: function (datum) {
      return (
        datum.substring(0, 2) + "." +
        datum.substring(2, 4) + "." +
        datum.substring(4, 8)
      );
    },

    heutigesDatum: function () {
      var teile = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/Berlin",
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }).formatToParts(new Date());

      var jahr = "";
      var monat = "";
      var tag = "";

      teile.forEach(function (teil) {
        if (teil.type === "year") {
          jahr = teil.value;
        }
        if (teil.type === "month") {
          monat = teil.value;
        }
        if (teil.type === "day") {
          tag = teil.value;
        }
      });

      return jahr + "-" + monat + "-" + tag;
    },

    grafikAnzeigen: function (eintrag) {
      this.ausgewaehlterVorfall = eintrag;
    },

    grafikSchliessen: function () {
      this.ausgewaehlterVorfall = null;
    },

    datumAktualisieren: function () {
      this.heute = this.heutigesDatum();
    }
  },

  created: function () {
    this.datumAktualisieren();
  },

  mounted: function () {
    this.datumsTimer = setInterval(
      this.datumAktualisieren,
      60000
    );
  },

  beforeUnmount: function () {
    clearInterval(this.datumsTimer);
  }
};
</script>

<style scoped>
.cyber-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.cyber-popup {
  background: white;
  border-radius: 8px;
  padding: 20px;
  width: 95%;
  max-width: 1500px;
  max-height: 95vh;
  overflow: auto;
}

.cyber-grafik {
  display: block;
  width: 100%;
  height: auto;
  max-height: 80vh;
  object-fit: contain;
}
</style>
